import React from 'react';
import Box from '@mui/material/Box';
import HourglassBottomIcon from '@mui/icons-material/HourglassBottom';
import LinearProgress from '@mui/material/LinearProgress';
import Typography from '@mui/material/Typography';
import { string } from 'prop-types';

const DataLoadingCard = ({ type }) => {
  return (
    <Box
      alignItems="center"
      bgcolor="graphic.lighter"
      borderRadius="4px"
      color="text.secondary"
      display="flex"
      flexDirection="column"
      fontFamily="Overpass"
      fontWeight={300}
      height="100%"
      justifyContent="center"
      padding={3}
      textAlign="center"
      width="100%"
    >
      <HourglassBottomIcon
        sx={{
          color: '_next.text.secondary',
          fill: '_next.text.secondary',
          height: 24,
          mb: 1,
          width: 24,
        }}
      />
      <Typography
        sx={{
          color: '_next.text.primary',
          textAlign: 'center',
        }}
        variant="h6"
      >
        Loading {type ?? 'data'}.
      </Typography>
      <Typography sx={{ color: '_next.text.primary', textAlign: 'center' }} variant="body1">
        Large data sets may take some time.
      </Typography>
      <LinearProgress
        sx={{
          gap: 1,
          height: 4,
          mt: 3,
          width: '15%',
        }}
      />
    </Box>
  );
};

DataLoadingCard.propTypes = {
  type: string,
};

DataLoadingCard.defaultProps = {
  type: null,
};

export default DataLoadingCard;
